"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChartData = isChartData;
exports.isDatasetData = isDatasetData;
exports.isServerData = isServerData;
/**
 * Determines if the given object satisfies ChartData.
 */
function isChartData(obj) {
    return 'labels' in obj;
}
/**
 * Determines if obj satisfies ChartData.
 */
function isDatasetData(obj) {
    return 'name' in obj && 'values' in obj;
}
/**
 * Determine if the given  object satisfies ServerData.
 */
function isServerData(obj) {
    return ('chart' in obj && 'datasets' in obj && isChartData(obj.chart) && obj.datasets.every(function (d) { return isDatasetData(d); }));
}
